import React, { useState } from 'react';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { warehouseObjState } from '../../../../atoms/WarehouseObjState';
import { warehouseDetailUsersState } from '../../../../atoms/WarehouseState';
import Delete from '../../../../components/Dialog/Delete';
import ListHeader from '../../../../components/ListHeader';
import styles from '../styles';

Info.propTypes = {
  title: PropTypes.string,
  headings: PropTypes.array.isRequired,
  labelAddBtn: PropTypes.string,
  labelAddBtn2: PropTypes.string,
  datas: PropTypes.array,
  remove: PropTypes.func,
  removeLabelApprove: PropTypes.string,
  displayAddScreen: PropTypes.func,
  displayAddScreen2: PropTypes.func,
  isPrinter: PropTypes.bool,
};

function Info(props) {
  const { classes } = styles();
  const {
    title = null,
    headings = [],
    datas = [],
    labelAddBtn,
    labelAddBtn2,
    remove = null,
    displayAddScreen,
    displayAddScreen2,
    removeLabelApprove = null,
    isPrinter = false,
    btnAddLabel = null,
  } = props;

  const [onDelete, setOnDelete] = useState(false);
  const [order, setOrder] = useRecoilState(warehouseDetailUsersState);
  const warehouse = useRecoilValue(warehouseObjState);
  const [deleteItem, setDeleteItem] = useState({ id: null, name: null });

  function handleRemove(id) {
    if (remove) {
      remove(id);
    }
    setOnDelete(false);
  }

  function handleDisplayAddScreen(e) {
    displayAddScreen(e);
  }

  function handleDisplayAddScreen2(e) {
    displayAddScreen2(true);
  }

  function handleOnClickRemove(item) {
    setOnDelete(true);
    setDeleteItem(item);
  }

  const handleRequestSort = (event, property) => {
    const isDesc = order.order_by === property && order.desc;
    setOrder({
      desc: !isDesc,
      order_by: property,
    });
  };

  return (
    <Paper className={classes.Info} elevation={0}>
      <div className="info-header">
        <Typography variant="h5" color="secondary">
          {title}
        </Typography>
        <div>
          <Button variant="contained" color="primary" onClick={handleDisplayAddScreen}>
            {labelAddBtn}
          </Button>
          {labelAddBtn2 && (
            <Button variant="contained" color="primary" onClick={handleDisplayAddScreen2}>
              {labelAddBtn2}
            </Button>
          )}
        </div>
      </div>

      <TableContainer>
        <Table className={classes.Table} aria-labelledby="tableTitle" aria-label="enhanced table" hidesorticon="true">
          <ListHeader
            fields={headings}
            desc={order.desc}
            orderBy={order.order_by}
            onRequestOrder={handleRequestSort}
            rowCount="1"
            classTableSortLabel={classes.tableSortLabel}
          />
          <TableBody className={classes.TableBody}>
            {datas.length !== 0 ? (
              datas.map((item, index) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={true}
                    tabIndex={-1}
                    key={`row-${index}`}
                    selected={true}
                  >
                    {Object.keys(item).map((cellKey, cellIndex) => {
                      let headingLength = isPrinter === true ? headings.length - 1 : headings.length; // Remove id in printer case
                      if (cellIndex < headingLength) {
                        return <TableCell key={`cell-${cellIndex}`}>{item[cellKey]}</TableCell>;
                      }
                    })}
                    <TableCell align="right">
                      <Link
                        to="#"
                        variant="body2"
                        onClick={() => {
                          handleOnClickRemove(item);
                        }}
                      >
                        Remove
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow />
            )}
            {onDelete && (
              <Delete
                labelCancel="NO"
                labelApprove={removeLabelApprove}
                content={'Are you sure to remove ' + deleteItem.name + ' from ' + warehouse.alias + ' ?'}
                handleCancel={(e) => setOnDelete(false)}
                handleApprove={() => handleRemove(deleteItem.id)}
              ></Delete>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default Info;
